const state = {
  isBack: false,
  isReplace: false,
  inds: 0,
  refresh: true,
  userRefresh: 0,
  mapRefresh: 0,
  otherRefresh: 0,
  exitapp_status: 0,
  routeAction: 'push',
  homeRefresh: 0,
  showMy: false,
  isRoot: false,
  isMonitor: false,
  userInfo: '',
  address: {},
  feeInfo: {}, //维修点 材料费 自定义
  feeInfoList: [],
  city: ''
}
const mutations = {
  changeIsBack(state, flag) {
    state.isBack = flag
  },
  isReplace(state, flag) {
    state.isReplace = flag
  },
  changeInds(state, flag) {
    state.inds = flag
  },
  changeRefresh(state, flag) {
    state.refresh = flag
  },
  changeUser(state, flag) {
    state.userRefresh = flag;
  },
  changeMap(state, flag) {
    state.mapRefresh = flag;
  },
  changeOther(state, flag) {
    state.otherRefresh = flag;
  },
  changeExitappStatus(state, flag) {
    state.exitapp_status = flag;
  },
  changeHome(state, flag) {
    state.homeRefresh = flag;
  },
  showMy(state, flag){
    state.showMy = flag
  },
  isRoot(state, flag){
    state.isRoot = flag
  },
  isMonitor(state, flag){
    state.isMonitor = flag
  },
  setUser(state, flag) {
    state.userInfo = flag
  },
  setAddress(state, flag) {
    state.address = flag
  },
  setFeeInfo(state, flag) {
    state.feeInfo = flag
  },
  addFeeList(state, flag) {
    state.feeInfoList = flag
  },
  setCity(state,flag) {
    state.city = flag
  }
}
export default {
  state,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/routerState.js